import React from "react";
import styles from "./Navbar.module.css";

function Navbar() {
  window.addEventListener("click", (e) => {
    if (
      e.target.id !== "dropDown" &&
      e.target.id !== "tripledot" &&
      e.target.id !== "openarrow"
    ) {
      document.getElementById("dropDown").style.display = "none";
    }
  });
  const openDropdown = (e) => {
    document.getElementById("dropDown").style.display = "block";
    // console.log("arrow clickerd");
  };

  const closeDropdown = (e) => {
    document.getElementById("dropDown").style.display = "none";
    // console.log("arrow clickerd");
  };

  return (
    <div className={styles.container}>
      <div className={styles.navLeft}>
        <a className={styles.portfolioWord} href="#home">
          <span className={styles.logoR}>R</span>ag
          <span className={styles.hLet}>h</span>av
        </a>
        <span className={styles.visitWord}> Visit =&nbsp;</span>
        <div className={styles.objectDropdown} id="dropDown">
          <span>
            <span className={styles.bracket}>(</span>
            <span className={styles.brace}> &#123; </span>
          </span>
          <p>
            <a href="#home">Home</a>
            <span className={styles.coma}>,</span>
          </p>
          <p>
            <a href="#skills">Skills</a>
            <span className={styles.coma}>,</span>
          </p>
          <p>
            <a href="#projects">Projects</a>
            <span className={styles.coma}>,</span>
          </p>
          <p>
            <a href="#contactMe">Contact</a>
          </p>
          <span>
            <span className={styles.brace}> &#125; </span>
            <span className={styles.bracket}>)</span>{" "}
            <span className={styles.arrow} onClick={closeDropdown}>
              &lt;=
            </span>
          </span>
        </div>
      </div>
      <div className={styles.navList}>
        <div className={styles.align}>
          <span className={styles.bracket}>(</span>
          <span className={styles.brace}>&#123;</span>
        </div>
        <span className={styles.dots} id="tripledot" onClick={openDropdown}>
          ...
        </span>
        <p>
          <a href="#home">Home</a>
          <span className={styles.coma}>,</span>
        </p>
        <p>
          <a href="#skills">Skills</a>
          <span className={styles.coma}>,</span>
        </p>
        <p>
          <a href="#projects">Projects</a>
          <span className={styles.coma}>,</span>
        </p>
        <p>
          <a href="#contactMe">Contact</a>
        </p>
        <div className={styles.align}>
          <span className={styles.brace}>&#125;</span>
          <span className={styles.bracket}>)</span>
          <span className={styles.arrow} id="openarrow" onClick={openDropdown}>
            =&gt;
          </span>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
